// Overlay.js
import React from 'react';
import './Overlay.css';

const Overlay = ({ url, onClose }) => {
  return (
    <div className="overlay">
      <button className="close-btn" onClick={onClose}>
        X
      </button>
      <iframe title="Overlay Content" src={url} allow="fullscreen; encrypted-media" className="overlay-iframe" />
    </div>
  );
};

export default Overlay;
